<template>
  <div class="pcc-carriers">
    <div v-for="c in carriers" :key="c.carrier" class="pcc-carrier" :class="{ 'pcc-carrier--used': c.carrier === usedCarrier }">
      <div class="pcc-carrier-head">
        <img :src="'/img/logo-' + c.carrier.toLowerCase() + '.png'" :alt="c.carrier" />
        <span v-if="c.carrier === usedCarrier" class="pcc-badge">{{ usedLabel }}</span>
      </div>
      <div v-if="!c.available" class="pcc-text">{{ $t("parcelCalculator.unavailable." + c.unavailableReason) }}</div>
      <table v-else class="pcc-mini">
        <tr v-for="row in c.rows" :key="row.key" :class="{ 'pcc-zero': row.amount === 0 }">
          <td>{{ $t("parcelCalculator.rows." + row.key) }}</td>
          <td class="pcc-amount">{{ row.amount === 0 ? "–" : eur(row.amount, 5) }}</td>
        </tr>
        <tr class="pcc-sum">
          <td>{{ $t("parcelCalculator.priceRegular") }}</td>
          <td class="pcc-amount">{{ eur(c.totalRegular, 2) }}</td>
        </tr>
      </table>
      <ul v-if="c.warnings && c.warnings.length" class="pcc-warnings">
        <li v-for="w in c.warnings" :key="w">{{ $te("parcelCalculator.warnings." + w) ? $t("parcelCalculator.warnings." + w) : w }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
/** Preise je Paketdienst (DHL/DPD) fuer ein Paket mit Zuschlaegen und Hinweisen; der Versanddienst des Produkts ist gruen umrandet. */
export default {
  name: "ParcelCarrierCards",
  props: {
    carriers: { type: Array, default: () => [] },
    usedCarrier: { type: String, default: "" },
    usedLabel: { type: String, default: "" },
  },
  methods: {
    eur(value, decimals) {
      return value == null ? "–" : `${this.$options.filters.formatNumberGerman(value, decimals)} €`;
    },
  },
};
</script>

<style scoped>
.pcc-carriers {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.pcc-carrier {
  flex: 1 1 280px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 10px 12px;
}
.pcc-carrier--used {
  border-color: #7f915a;
}
.pcc-carrier-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}
.pcc-carrier-head img {
  height: 30px;
  width: auto;
  border-radius: 0 !important;
}
.pcc-badge {
  font-size: 11px;
  color: #7f915a;
  background: #f1f5e8;
  border-radius: 10px;
  padding: 1px 8px;
}
.pcc-mini {
  width: 100%;
  font-size: 12px;
  border-collapse: collapse;
}
.pcc-mini td {
  padding: 3px 0;
  border-bottom: 1px solid #f0f0f0;
}
.pcc-amount {
  text-align: right;
  white-space: nowrap;
}
.pcc-sum td {
  font-weight: 600;
}
.pcc-zero {
  color: #aaa;
}
.pcc-text {
  font-size: 12px;
  color: #777;
}
.pcc-warnings {
  margin: 8px 0 0;
  padding-left: 16px;
  color: #b26a00;
  font-size: 12px;
}
</style>
